import AppDispatcher from '../../../dispatcher/AppDispatcher';
import Ajax from '../../../utils/Ajax';
import CashWalletConstants from './CashWalletConstants';

const CashWalletActions = {
    getDashboard: function () {
        AppDispatcher.handleAction({
            actionType: CashWalletConstants.RETRIEVE_DASHBOARD,
        });

        return Ajax.getCashWalletDashboard()
            .done(function (response) {
                AppDispatcher.handleAction({
                    actionType: CashWalletConstants.DASHBOARD_SUCCEEDED,
                    data: { response },
                });
            })
            .fail(function (error) {
                console.error('Error while getting cash wallet dashboard: ', error);
                AppDispatcher.handleAction({
                    actionType: CashWalletConstants.DASHBOARD_FAILED,
                    data: { error },
                });
            });
    },

    getRequests: function (page) {
        AppDispatcher.handleAction({
            actionType: CashWalletConstants.RETRIEVE_REQUESTS,
        });

        return Ajax.getCashWalletRequests(page)
            .done(function (response) {
                AppDispatcher.handleAction({
                    actionType: CashWalletConstants.REQUESTS_SUCCEEDED,
                    data: { response },
                });
            })
            .fail(function (error) {
                console.error('Error while getting cash wallet requests: ', error);
                AppDispatcher.handleAction({
                    actionType: CashWalletConstants.REQUESTS_FAILED,
                    data: { error },
                });
            });
    },

    getRequestDetail: function (id) {
        AppDispatcher.handleAction({
            actionType: CashWalletConstants.RETRIEVE_REQUEST_DETAIL,
        });

        return Ajax.getCashWalletRequestDetail(id)
            .done(function (response) {
                AppDispatcher.handleAction({
                    actionType: CashWalletConstants.REQUEST_DETAIL_SUCCEEDED,
                    data: { response },
                });
            })
            .fail(function (error) {
                console.error('Error while getting cash wallet request detail: ', error);
                AppDispatcher.handleAction({
                    actionType: CashWalletConstants.REQUEST_DETAIL_FAILED,
                    data: { error },
                });
            });
    },

    resetSubmit: function () {
        AppDispatcher.handleAction({
            actionType: CashWalletConstants.RESET_SUBMIT,
        });
    },

    submitRequest: function (payload) {
        AppDispatcher.handleAction({
            actionType: CashWalletConstants.SUBMIT_REQUEST,
        });

        return Ajax.submitCashWalletRequest(payload)
            .done(function (response) {
                AppDispatcher.handleAction({
                    actionType: CashWalletConstants.SUBMIT_SUCCEEDED,
                    data: { response },
                });
            })
            .fail(function (error) {
                console.error('Error while submitting cash wallet request: ', error);
                AppDispatcher.handleAction({
                    actionType: CashWalletConstants.SUBMIT_FAILED,
                    data: { error, code: error?.responseJSON?.error },
                });
            });
    },

    cancelRequest: function (id) {
        AppDispatcher.handleAction({
            actionType: CashWalletConstants.CANCEL_REQUEST,
        });

        return Ajax.cancelCashWalletRequest(id)
            .done(function (response) {
                AppDispatcher.handleAction({
                    actionType: CashWalletConstants.CANCEL_SUCCEEDED,
                    data: { response },
                });
            })
            .fail(function (error) {
                console.error('Error while cancelling cash wallet request: ', error);
                AppDispatcher.handleAction({
                    actionType: CashWalletConstants.CANCEL_FAILED,
                    data: { error, code: error?.responseJSON?.error },
                });
            });
    },
};

export default CashWalletActions;
